import React from 'react';
import BlockedPage
from '../pages/security/BlockedPage';
import {ACCOUNT_STATUS} from '../constants/accountStatus';
import PendingPage from '../pages/security/PendingPage';
import SuspendedPage from '../pages/security/SuspendedPage';
import LegalConsentPage from '../pages/auth/LegalConsentPage';
import { isSubscriptionExpired } from '../utils/subscriptionUtils';
import type { Timestamp } from 'firebase/firestore';
interface Props {
  accountStatus: string | null;
  subscriptionExpiresAt: Timestamp | null;
  legalAcceptanceAccepted: boolean;
  children: React.ReactNode;
}

export default function
AccountStatusGuard({
accountStatus,
subscriptionExpiresAt,
legalAcceptanceAccepted,
children
}: Props) {
    
  if (
  accountStatus ===
  ACCOUNT_STATUS.BLOCKED
) {

  return (
    <BlockedPage />
  );
}

if (
  accountStatus ===
  ACCOUNT_STATUS.SUSPENDED
) {

  return (
    <SuspendedPage />
  );
}

if (
  accountStatus ===
  ACCOUNT_STATUS.PENDING
) {

  if (!legalAcceptanceAccepted) {
    return (
      <LegalConsentPage />
    );
  }

  return (
    <PendingPage />
  );
}

  if (
  accountStatus !== ACCOUNT_STATUS.ACTIVE ||
  isSubscriptionExpired(subscriptionExpiresAt)
) {
  return <SuspendedPage />;
}

return (
  <>
    {children}
  </>
);
}
